import { IonButton, IonCol, IonGrid, IonIcon, IonRow, IonText } from '@ionic/react';
import { trashBinOutline } from 'ionicons/icons';
import { ChangeEvent, DragEvent, MouseEvent, useRef, useState } from 'react';

import { Button } from '@/components/Button';
import { FileInput } from '@/components/FileInput/fileInput';
import { Tag } from '@/components/Tag/Tag';

import { mergeClassNames } from '@/utils/mergeClassNames';

import CsvFileIcon from '@/assets/icons/csvFileIcon.svg';
import FileUploadIcon from '@/assets/icons/fileUploadIcon.svg';

import styles from './uploadArea.module.css';

export interface IUploadAreaProps {
  onChange?: ((files: FileList) => void) | undefined;
  onFileRemove?: ((event: MouseEvent<HTMLIonButtonElement>) => void) | undefined;
}
export const UploadArea = ({ onChange, onFileRemove }: IUploadAreaProps) => {
  const [fileName, setFileName] = useState('');
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    console.log(files && files.length > 0);
    if (files && files.length > 0) {
      const filename = files.length > 1 ? `${files.length} files` : files[0].name;

      console.log({ event });

      setFileName(filename);
      onChange && onChange(files);
    }
  };

  // drag state
  const [dragActive, setDragActive] = useState(false);

  // handle drag events
  const handleDrag = function (e: any) {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === 'dragenter' || e.type === 'dragover') {
      setDragActive(true);
    } else if (e.type === 'dragleave') {
      setDragActive(false);
    }
  };

  // triggers when file is dropped
  const handleDrop = function (event: DragEvent<HTMLDivElement>) {
    event.preventDefault();
    event.stopPropagation();
    setDragActive(false);
    const files = event.dataTransfer.files;

    if (files && files.length > 0) {
      const filename = files.length > 1 ? `${files.length} files` : event.dataTransfer.files[0].name;
      setFileName(filename);
      onChange && onChange(files);
    }
  };

  const handleClick = function (event: MouseEvent<HTMLDivElement> | MouseEvent<HTMLIonButtonElement>) {
    event.stopPropagation();
    setDragActive(false);

    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  return (
    <IonGrid fixed>
      <div
        className={mergeClassNames(dragActive && 'dragActive', styles.inner)}
        onClick={handleClick}
        onDragEnter={handleDrag}
        onDragLeave={handleDrag}
        onDragOver={handleDrag}
        onDrop={handleDrop}
        onSubmit={(e) => e.preventDefault()}>
        <IonRow className='ion-justify-content-center'>
          <IonIcon
            className={mergeClassNames(dragActive && styles.activeIcon, styles.icon)}
            src={fileName ? CsvFileIcon : FileUploadIcon}
          />
        </IonRow>
        {fileName ? (
          <>
            <IonRow className='ion-justify-content-center'>
              <IonCol className='ion-justify-content-center'>
                <IonButton
                  className='errorIcon'
                  expand='full'
                  fill='clear'
                  onClick={(event) => {
                    event.preventDefault();
                    setFileName('');
                    onFileRemove && onFileRemove(event);
                  }}
                  size='small'>
                  <IonIcon slot='icon-only' src={trashBinOutline} />
                </IonButton>
                <IonText className={styles.title}>{fileName.toString()}</IonText>
              </IonCol>
            </IonRow>
          </>
        ) : (
          <>
            <IonRow className='ion-justify-content-center'>
              <IonCol>
                <FileInput onChange={handleFileChange} ref={fileInputRef}>
                  <Button onClick={handleClick} size='small'>
                    Choose a file
                  </Button>
                </FileInput>
              </IonCol>
            </IonRow>
          </>
        )}
      </div>
      <IonRow>
        <IonCol>
          <Tag size='sm'>.CSV files only</Tag>
        </IonCol>
      </IonRow>
    </IonGrid>
  );
};
